import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  delete map strategy
export const DeleteMapStrategies = createSlice({
  name: "DeleteMapStrategies",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    delete_MapStrategies: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_delete_MapStrategies: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_delete_MapStrategies: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    delete_MapStrategies_is_success: (state, action) => {
      state.isSuccess = false;
    },
    false_switchdeletemap_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default DeleteMapStrategies.reducer;
export const {
  delete_MapStrategies,
  success_api_call_delete_MapStrategies,
  failure_api_call_delete_MapStrategies,
  delete_MapStrategies_is_success,
  false_switchdeletemap_response
} = DeleteMapStrategies.actions;
